import { ValidationObserver, ValidationProvider } from "vee-validate";
import { MaintenanceType } from "@/models/MaintenanceType";

export default {
  name: "MaintenanceManagementDialog",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      loading: false,
      isAdd: false,
      isUpdate: false,
      iconsList: [
        {
          icon: "mdi-battery-alert",
          value: "batteryAlert"
        },
        {
          icon: "mdi-spray-bottle",
          value: "sprayBottle"
        },
        {
          icon: "mdi-lightbulb-outline",
          value: "lightbulbOutline"
        },
        {
          icon: "mdi-toilet",
          value: "toilet"
        },
        {
          icon: "mdi-pipe-valve",
          value: "pipeValve"
        },
        {
          icon: "mdi-bed",
          value: "bed"
        },
        {
          icon: "mdi-comment",
          value: "comment"
        },
        {
          icon: "mdi-snowflake",
          value: "snowflake"
        },
        {
          icon: "mdi-tablet",
          value: "tablet"
        },
        {
          icon: "mdi-tablet-cellphone",
          value: "tabletCellphone"
        },
      ],
      maintenanceType: new MaintenanceType()
    }
  },
  computed: {
    facilityId() {
      return this.$store.state.authModule.currentFacility;
    },
    maintenanceCategories() {
      return this.$store.getters.maintenanceCategories;
    },
  },
  watch: {
    'maintenanceType.categoryId'(categoryId) {
      if(categoryId != null) {
        this.maintenanceType.category = this.maintenanceCategories?.find(x => x.id === categoryId)?.name;
      }
    },
  },
  methods: {
    async submit() {
      this.loading = true;

      if (this.isAdd) {
        await this.addMaintenanceType();
      }

      if (this.isUpdate) {
        await this.updateMaintenanceType();
      }

      this.close();
    },
    async addMaintenanceType() {
      const maintenanceType = Object.assign({}, this.maintenanceType);
      maintenanceType.facilityId = this.facilityId;
      this.loading = true;

      this.$store.dispatch("createMaintenanceType", maintenanceType)
        .then(() => {
          this.$toast.open({
            type: "success",
            message: this.$t("MaintenanceManagement.MaintenanceTypeSuccessAdded")
          });

          this.close();
        }).catch((error) => {
          this.$toast.open({
            type: "error",
            message: error.message
          });

          this.loading = false;
      });
    },
    async updateMaintenanceType() {
      const maintenanceType = Object.assign({}, this.maintenanceType);
      this.loading = true;

      this.$store.dispatch("updateMaintenanceType", maintenanceType)
        .then(() => {
          this.$toast.open({
            type: "success",
            message: this.$t("MaintenanceManagement.MaintenanceTypeSuccessUpdated")
          });

          this.close();
        }).catch((error) => {
        this.$toast.open({
          type: "error",
          message: error.message
        });

        this.loading = false;
      });
    },
    open(maintenanceType, action: string) {
      this.dialog = true;

      if (action === "add") {
        this.isAdd = true;
      }

      if (action === "update") {
        this.isUpdate = true;
        this.maintenanceType = Object.assign({}, maintenanceType);

        if(this.maintenanceType?.category?.length && !this.maintenanceType?.categoryId?.length) {
          this.maintenanceType.categoryId = this.maintenanceCategories.find(x => x.name === this.maintenanceType.category)?.id;
        }
      }
    },
    close() {
      this.loading = false;
      this.dialog = false;
      this.isAdd = false;
      this.isUpdate = false;
      delete this.maintenanceType.id;
      this.maintenanceType.name = "";
      this.maintenanceType.categoryId = "";
      this.maintenanceType.category = "";
      this.maintenanceType.icon = "";
      this.maintenanceType.department = "";
      this.$refs.observer.reset();
    },
  },
  mounted() {
    console.log("CATEGORIES ", this.maintenanceCategories)
  }
}